function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { FormControl } from './FormControl';
const helperTextStyles = process.env.NODE_ENV === "production" ? {
  name: "xph15n",
  styles: "display:grid;grid-template-rows:repeat(1, minmax(0, 1fr));grid-template-columns:1fr auto;column-gap:1rem"
} : {
  name: "1yczryj-helperTextStyles",
  styles: "display:grid;grid-template-rows:repeat(1, minmax(0, 1fr));grid-template-columns:1fr auto;column-gap:1rem;label:helperTextStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function getLength(value) {
  if (typeof value === 'string') {
    return value.length;
  }
  return 0;
}
export function FormControlLength(props) {
  const {
    value,
    maxLength,
    forceShowLength = false
  } = props;
  const fieldLength = getLength(value);
  const lengthDisplay = `${fieldLength}/${maxLength}`;
  const error = props.error || fieldLength > maxLength;
  return <FormControl {...props} error={error} helperText={<div css={helperTextStyles}>
					<div>{props.helperText}</div>
					<div>
						{forceShowLength || fieldLength > maxLength ? lengthDisplay : null}
					</div>
				</div>} />;
}